<template><div class="app-brand"><img class="brand-logo" src="/brand-logo.png" alt="中竞发 Logo"/><div><strong>知识库中心</strong></div></div></template>
